import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();

    const isCatalogPage = location.pathname.includes('/catalog');

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const closeAll = () => {
        setIsOpen(false)
        setIsSearchOpen(false)
    }

    // Динамический стиль фона хедера 
    const headerBackground = (isScrolled || isCatalogPage)
        ? '#000' // Черный, если есть прокрутка по или пользователь находится в разделе каталог
        : 'linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, transparent 100%)';

    return (
        <>
            <header style={{...styles.header, background: headerBackground}}>
                {/* Иконка Бургера */}
                <div style={styles.menuTrigger} onClick={() => setIsOpen(true)}>
                    <div style={styles.line}></div>
                    <div style={styles.line}></div>
                </div>

                {/* Центральный логотип */}
                <div style={styles.logo}>
                    <Link to="/" style={styles.logoLink}>PREMIUM AUTO</Link>
                </div>

                <div style={styles.langSwitch}>
                    <span>РУССКИЙ</span> | <span>O'ZBEKCHA</span>
                </div>

            </header>

            {/* Боковое меню (Drawer) */}
            <div style={{
                ...styles.drawer, 
                transform: isOpen ? 'translateX(0)' : 'translateX(-110%)',
                opacity: isOpen ? 1 : 0
                }}>
                <div style={styles.drawerHeader}>
                    <div style={styles.closeBtn} onClick={() => setIsOpen(false)}>✕</div>
                </div>    

                <nav style={styles.nav}>
                    <Link to="/" style={styles.navLink} onClick={closeAll}>Главное меню</Link>
                    <Link to="/catalog/new" style={styles.navLink} onClick={closeAll}>BMW в наличии</Link>
                    <Link to="/catalog/used" style={styles.navLink} onClick={closeAll}>BMW c пробегом</Link>
                    <Link to="/service" style={styles.navLink} onClick={closeAll}>Сервис</Link>
                    <Link to="/about" style={styles.navLink} onClick={closeAll}>О нас</Link>
                    <Link to="/contacts" style={styles.navLink} onClick={closeAll}>Контакты</Link>
                </nav>
            </div>

            {/* Затемнение фона */}
            {isOpen && <div style={styles.overlay} onClick={() => setIsOpen(false)}></div>}
        </>
    );
};

const styles = {
    header: {
        position: 'fixed',
        top: 0,
        width: '100%',
        height: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 50px',
        zIndex: 1000,
        color: '#fff',
        transition: 'background 0.4s ease',
    },

    menuTrigger: { 
        cursor: 'pointer', 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '5px' 
    },

    line: { 
        width: '35px', 
        height: '4px', 
        backgroundColor: '#fff',
        borderRadius: '5px',
    },

    logoLink: { 
        marginLeft: '80px',
        color: '#fff', 
        textDecoration: 'none', 
        fontFamily: 'Arial, sans-serif',
        fontSize: '18px', 
        letterSpacing: '2px', 
        fontWeight: 'bold' 
    },

    drawer: {
        position: 'fixed',
        top: '20px',
        left: '20px',
        width: '350px',
        height: 'calc(100% - 40px)', // Чтобы боковое меню не доходила до низа
        backgroundColor: '#fff',
        zIndex: 2001,
        transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
        padding: '40px',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '20px 0 60px rgba(0,0,0,0.1)',
        borderRadius: '5px',
    },

    drawerHeader: {
        display: 'flex', 
        justifyContent: 'flex-start'
    },

    closeBtn: { 
        fontSize: '24px', 
        cursor: 'pointer', 
        textAlign: 'right', 
        color: '#000' 
    },

    nav: { 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '20px', 
        marginTop: '50px' 
    },

    navLink: { 
        color: '#444242', 
        textDecoration: 'none',
        fontFamily: 'Verdana, sans-serif',
        fontSize: '18px', 
        fontWeight: '300',
        transition: '0.3sx' 
    },

    langSwitch: { 
        fontSize: '12px', 
        fontFamily: 'Arial sans-serif',
        display: 'flex',
        gap: '8px',
        color: '#ffffff' 
    },

    overlay: { 
        position: 'fixed', 
        top: 0, 
        left: 0, 
        width: '100%', 
        height: '100%', 
        backgroundColor: 'rgba(0,0,0,0.5)', 
        backdropFilter: 'blur(5px)', // Размытие заднего фона
        zIndex: 1500 
    }
};

export default Header;